import * as axios from "../../utilities/axios"

export const create = (dataObject, sessionToken) => {
  if (!dataObject.telemetry) {
    dataObject.telemetry = {
      origin_create: "v2 web app",
    }
  }
  return axios
    .secure(sessionToken)
    .post(`api/v1/trafficticket/create`, dataObject)
    .then(({ data }) => data)
    .catch(axios.parseError)
}
